let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("71E0U")).then(() => parcelRequire('gfNaO'));